import React, { useContext, useEffect } from "react";
import {
  BrowserRouter as Routes,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { useClearCache } from "react-clear-cache";
import { Helmet } from "react-helmet";

import Login from "./view/login";

import PrecalifacionesView from "./components/views/precalificaciones";
import PrecalifacionRowView from "./components/views/precalificacion";

import ParametrosView from "./components/views/parametros";

import AsesoresView from "./components/views/asesores";
import SectoresView from "./components/views/sectores";
import ContactoView from "./components/views/contacto";

import ClientesView from "./components/views/clientes";

import { Error404 } from "./components/views/error";
import { Adminlayout, Publiclayout, Signlayout } from "./components/Layout";

import "./App.css";

import SectoresProvider from "../src/components/views/sectores/context";
import ContactoProvider from "../src/components/views/contacto/context";

import AsesoresProvider from "../src/components/views/asesores/context";
import PrecalificacionesProvider from "../src/components/views/precalificaciones/context";
import ClientesProvider from "../src/components/views/clientes/context";

import { APIContext } from "./context";

function App() {
  const { checkAuth, checkUser, authenticated } = useContext(APIContext);
  const { isLatestVersion, emptyCacheStorage } = useClearCache();

  useEffect(() => {
    checkUser();

    if (!isLatestVersion) {
      console.log("No es la ultima versión");
      setTimeout(function (e) {
        e.preventDefault();
        emptyCacheStorage();
      }, 3000);
    } else {
      console.log("Actualizada ultima versión");
    }
  }, []);

  function MetaData() {
    return (
      <Helmet>
        <meta name="description" content="Administrador - Capital Factoring" />
      </Helmet>
    );
  }

  return (
    <div className="App">
      <MetaData />
      <Routes>
        <Switch>
          <Route exact path="/" render={() => <PublicContainer />} />

          <Route
            path="/(admin)"
            render={() =>
              checkAuth() ? <AdminContainer /> : <Redirect to="/" />
            }
          />

          <Route component={NotFound} />
        </Switch>
      </Routes>
    </div>
  );
}

const NotFound = () => (
  <Publiclayout>
    <Error404 />
  </Publiclayout>
);

const PublicContainer = () => (
  <Signlayout>
    <Route path="/" component={Login} />
  </Signlayout>
);

const AdminContainer = () => (
  <Adminlayout>
    {/* <DashboardProvider>
      <Route exact path="/admin" render={() => <DashboardView />} />
    </DashboardProvider> */}
    <PrecalificacionesProvider>
      <Route
        exact
        path="/admin"
        render={() => <Redirect to="/admin/precalificaciones" />}
      />
      <Route
        exact
        path="/admin/precalificaciones"
        render={() => <PrecalifacionesView />}
      />
      <Route
        exact
        path="/admin/precalificaciones-aprobadas"
        render={() => <PrecalifacionesView estado={1} />}
      />
      <Route
        exact
        path="/admin/precalificaciones-rechazadas"
        render={() => <PrecalifacionesView estado={2} />}
      />
      <Route
        exact
        path="/admin/precalificaciones/:id"
        render={(props) => <PrecalifacionRowView id={props.match.params.id} />}
      />
      <Route
        exact
        path="/admin/precalificaciones-aprobadas/:id"
        render={(props) => <PrecalifacionRowView id={props.match.params.id} />}
      />
      <Route
        exact
        path="/admin/precalificaciones-rechazadas/:id"
        render={(props) => <PrecalifacionRowView id={props.match.params.id} />}
      />
    </PrecalificacionesProvider>

    <Route
      exact
      path="/admin/parametros"
      render={(props) => <ParametrosView />}
    />

    <AsesoresProvider>
      <Route exact path="/admin/asesores" render={() => <AsesoresView />} />
    </AsesoresProvider>

    <SectoresProvider>
      <Route exact path="/admin/sectores" render={() => <SectoresView />} />
    </SectoresProvider>

    <ContactoProvider>
      <Route exact path="/admin/contacto" render={() => <ContactoView />} />
    </ContactoProvider>

    <ClientesProvider>
      <Route exact path="/admin/clientes" render={() => <ClientesView />} />
    </ClientesProvider>
  </Adminlayout>
);

export default App;
